module.exports = __webpack_public_path__ + "assets/favicons/browserconfig.xml";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/browserconfig.xml
// module id = 1235
// module chunks = 1